<template>
  <div>{{ uebung }}</div></template>

<script>
export default {
  name: 'uebung-activitas-absolve-component',
  props: {
    data: {
      type: Object,
      required: true,
      default: () => {
        return {
          uebung: {},
          metadata: {}
        }
      }
    }
  },
  data() {
    return {
        uebung: this.data.uebung,
        metadata: this.data.metadata
    }
  }
}

</script>
<style scoped></style>